import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment.prod';

@Component({
    selector: 'app-week-day-time-selection',
    templateUrl: './week-day-time-selection.component.html',
    styleUrls: ['./week-day-time-selection.component.scss'],
    standalone: false
})
export class WeekDayTimeSelectionComponent implements OnInit {
  @Input() daysHoursControl!: FormControl;
  @Input() defaultOpen: string = '12:00';
  @Input() defaultClose: string = '20:00';

  daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  selectedDays: string[] = [];
  hours: string[] = Array.from({ length: 24 }, (_, i) => ('0' + i).slice(-2));
  minutes: string[] = Array.from({ length: 12 }, (_, i) => ('0' + i * 5).slice(-2));
  deployUrl: string;

  ngOnInit() {
    if (!this.daysHoursControl.value) {
      this.daysHoursControl.setValue({});
    }
    this.deployUrl = environment.deploy_url;

    this.initializeSelectedDays();
  }

  initializeSelectedDays() {
    const currentValue = this.daysHoursControl.value;
    this.selectedDays = Object.keys(currentValue)
      .filter((day) => currentValue[day]?.open && currentValue[day]?.close)
      .sort((a, b) => this.daysOfWeek.indexOf(a) - this.daysOfWeek.indexOf(b));
  }

  toggleDay(day: string) {
    const currentValue = this.daysHoursControl.value;

    if (this.selectedDays.includes(day)) {
      this.selectedDays = this.selectedDays.filter((d) => d !== day);
      delete currentValue[day];
    } else {
      currentValue[day] = { open: this.defaultOpen, close: this.defaultClose };
      this.selectedDays.push(day);
    }

    this.selectedDays.sort((a, b) => this.daysOfWeek.indexOf(a) - this.daysOfWeek.indexOf(b));

    this.daysHoursControl.setValue(currentValue);
  }

  updateDayTime(day: string, field: 'open' | 'close', time: string) {
    const currentValue = this.daysHoursControl.value;

    if (!currentValue[day]) {
      currentValue[day] = { open: this.defaultOpen, close: this.defaultClose };
    }

    currentValue[day][field] = time;
    this.daysHoursControl.setValue(currentValue);
  }

  removeDay(day: string) {
    this.selectedDays = this.selectedDays.filter((d) => d !== day);
    const currentValue = this.daysHoursControl.value;
    delete currentValue[day];
    this.daysHoursControl.setValue(currentValue);
  }

  getHour(time: string | null): string {
    return time ? time.split(':')[0] : '00';
  }

  getMinute(time: string | null): string {
    return time ? time.split(':')[1] : '00';
  }
}
